import React from 'react';
import Typography from '../../components/Typography/Typography';

const Analytics = () => {
  return (
    <div className='flex-grow bg-white shadow-auth_box rounded-[15px] p-4 sm:p-6 lg:p-[50px] flex flex-col mb-8 sm:mb-16 lg:mb-[104px]'>
      <Typography variant="h2" className="font-bold title mb-2 sm:mb-4 text-xl sm:text-2xl lg:text-3xl">
        Analytics Dashboard
      </Typography>
      <Typography variant="body1" color="grey" className="mb-4 sm:mb-6 text-sm sm:text-base">
        View detailed analytics and insights for your KPMG operations.
      </Typography>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {/* Analytics Cards */}
        <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
          <Typography variant="h6" className="font-semibold mb-2 text-sm sm:text-base">
            Total Documents
          </Typography>
          <Typography variant="h3" className="text-k-dark-blue font-bold text-xl sm:text-2xl lg:text-3xl">
            1,234
          </Typography>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
          <Typography variant="h6" className="font-semibold mb-2 text-sm sm:text-base">
            Active Users
          </Typography>
          <Typography variant="h3" className="text-k-dark-blue font-bold text-xl sm:text-2xl lg:text-3xl">
            89
          </Typography>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
          <Typography variant="h6" className="font-semibold mb-2 text-sm sm:text-base">
            Verification Rate
          </Typography>
          <Typography variant="h3" className="text-k-dark-blue font-bold text-xl sm:text-2xl lg:text-3xl">
            98.5%
          </Typography>
        </div>
      </div>
      
      <div className="mt-6 sm:mt-8">
        <Typography variant="h4" className="font-semibold mb-2 sm:mb-4 text-lg sm:text-xl lg:text-2xl">
          Recent Activity
        </Typography>
        <div className="bg-gray-50 rounded-lg p-4 sm:p-6">
          <Typography variant="body1" color="grey" className="text-sm sm:text-base">
            Analytics data will be displayed here. This is a placeholder for future analytics implementation.
          </Typography>
        </div>
      </div>
      
    </div>
  );
};

export default Analytics;
